/**
 * useHighlightedAccount (KAN-645)
 *
 * Account id from `?account=<id>` (links from the dashboard and the dialog to
 * Settings > Telegram). Once the rows are rendered, the first highlighted row
 * inside `containerRef` is scrolled into view, one time per account id, so the
 * periodic list refetch does not jump the page back.
 */
import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

export const HIGHLIGHT_ATTR = 'data-highlighted'

export function useHighlightedAccount<T extends HTMLElement>(ready: boolean) {
  const [searchParams] = useSearchParams()
  const accountId = (searchParams.get('account') ?? '').trim()
  const containerRef = useRef<T | null>(null)
  const scrolledFor = useRef<string>('')

  useEffect(() => {
    if (!ready || !accountId || scrolledFor.current === accountId) return
    const row = containerRef.current?.querySelector<HTMLElement>(
      `[${HIGHLIGHT_ATTR}="true"]`
    )
    if (!row) return
    scrolledFor.current = accountId
    row.scrollIntoView?.({ block: 'center', behavior: 'smooth' })
  })

  return { accountId, containerRef }
}
